const BOOKMARKS_KEY = 'pw:bookmarks';
const NOTIFIED_KEY = 'pw:notified-events';
const REMINDERS_KEY = 'pw:reminders-enabled';
const REMIND_WINDOW_MS = 60 * 60 * 1000;
const CHECK_INTERVAL_MS = 60 * 1000;
const MAX_PER_TICK = 5;
const SW_PATH = '/sw.js';
const ICON = '/assets/icon-192x192.png';

function readBookmarks() {
    try {
        const parsed = JSON.parse(localStorage.getItem(BOOKMARKS_KEY) || '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
}

function readNotified() {
    try {
        const parsed = JSON.parse(localStorage.getItem(NOTIFIED_KEY) || '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
}

function remindersEnabled() {
    try {
        return localStorage.getItem(REMINDERS_KEY) === 'true';
    } catch (error) {
        return false;
    }
}

function setRemindersEnabled(enabled) {
    try {
        localStorage.setItem(REMINDERS_KEY, enabled ? 'true' : 'false');
    } catch (error) {
        console.error('Failed to save reminders preference:', error);
    }
}

function startTimeFor(entry) {
    if (!entry || entry.type !== 'event') return null;
    const datePart = entry.date ? String(entry.date).slice(0, 10) : '';
    const timePart = entry.time || '';
    if (!datePart || !timePart) return null;
    const parsed = new Date(`${datePart}T${timePart}`);
    return Number.isNaN(parsed.getTime()) ? null : parsed.getTime();
}

function formatTime(timeStr) {
    const match = String(timeStr).match(/^(\d{1,2}):(\d{2})/);
    if (!match) return timeStr;
    const h = parseInt(match[1], 10);
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour = h % 12 || 12;
    return `${hour}:${match[2]} ${suffix}`;
}

function supportsNotifications() {
    return 'Notification' in window;
}

function permissionState() {
    return supportsNotifications() ? Notification.permission : 'unsupported';
}

function persistNotified(ids) {
    const active = new Set();
    readBookmarks().forEach((b) => {
        if (b.type === 'event') active.add(String(b.id));
    });
    try {
        localStorage.setItem(NOTIFIED_KEY, JSON.stringify([...ids].filter((id) => active.has(id))));
    } catch (error) {
        console.error('Failed to persist event notifications:', error);
    }
}

async function showReminder(entry, startMs, nowMs) {
    const minsAway = Math.max(1, Math.round((startMs - nowMs) / 60000));
    const when = minsAway >= 60 ? 'in about an hour' : `in about ${minsAway} min`;
    const details = [
        entry.time ? formatTime(entry.time) : '',
        entry.charge || ''
    ].filter(Boolean).join(' · ');

    const title = entry.title || 'Pink Wallet event';
    const body = `Starts ${when}${details ? ` · ${details}` : ''}`;
    const tag = `pw-event-${entry.id}`;
    const url = `/events/${encodeURIComponent(String(entry.id))}/`;

    try {
        const registration = await navigator.serviceWorker.ready;
        if (registration.active) {
            registration.active.postMessage({ type: 'PW_NOTIFY', title, body, tag, url, icon: ICON, badge: ICON });
            return;
        }
    } catch (error) {
    }

    if (supportsNotifications() && Notification.permission === 'granted') {
        try {
            new Notification(title, { body, icon: ICON, badge: ICON, tag, data: { url } });
        } catch (error) {
            console.error('Failed to show notification:', error);
        }
    }
}

export function checkDueEvents() {
    if (permissionState() !== 'granted' || !remindersEnabled()) return;

    const now = Date.now();
    const notified = new Set(readNotified());
    const due = [];

    readBookmarks().forEach((entry) => {
        if (entry.type !== 'event') return;
        const id = String(entry.id);
        if (notified.has(id)) return;
        const start = startTimeFor(entry);
        if (start == null) return;
        if (start - now > REMIND_WINDOW_MS) return;
        if (now >= start) return;
        due.push({ entry, start });
    });

    if (due.length === 0) {
        persistNotified(notified);
        return;
    }

    due.slice(0, MAX_PER_TICK).forEach(({ entry, start }) => {
        showReminder(entry, start, now);
        notified.add(String(entry.id));
    });

    persistNotified(notified);
}

function handleBookmarksChanged() {
    checkDueEvents();
}

export function initEventNotifications() {
    if (window.__pwNotificationsInitialized) return;
    window.__pwNotificationsInitialized = true;

    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register(SW_PATH, { scope: '/' }).catch((error) => {
                console.error('Service worker registration failed:', error);
            });
        });
    }

    window.addEventListener('pw:bookmarks-changed', handleBookmarksChanged);
    window.addEventListener('pw:reminders-changed', checkDueEvents);
    window.addEventListener('load', checkDueEvents);
    setInterval(checkDueEvents, CHECK_INTERVAL_MS);
}